export default "__VITE_ASSET__494eaf77__"